import { css } from 'emotion';

import { colors } from '../../styles';

export const row = (justify: boolean) => css`
  display: flex;
  ${
    justify &&
    css`
    justify-content: space-between;
  `
  };
`;

export const filter = css`
  ${row(true)};
  margin-top: 30px;
`;

export const contentRow = (justify: boolean) => css`
  ${row(justify)};
  padding-top: 18px;

  &:nth-child(even) {
    background-color: ${colors.custom.lightestGray50};
  }
`;
